// extracted by mini-css-extract-plugin
export var chip = "_qx-0";
export var icon = "_qx-1";
export var remove = "_qx-2";
export var removeIcon = "_qx-3";